import * as React from "react";

const Building = ({ size = 20, color = '#198038', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill={color}
      d="M12 6h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2m0 4h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2M7 6h1a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m0 4h1a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m12 8h-1V1a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v17H1a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-8 0H9v-4h2zm5 0h-3v-5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v5H4V2h12z"
    ></path>
  </svg>
);

export default Building;
